// extracted by mini-css-extract-plugin
module.exports = {"scoreLine":"e__A","scoreRing":"e_0A","badge":"e_1A","badgeImage":"e_2A","spaced":"e_3A"};